import { t } from '@lingui/macro';

export const KEY_NAME_MIN_LENGTH = 3;
export const KEY_NAME_MAX_LENGTH = 64;
export const KEY_NAME_PATTERN = /^[A-Za-z0-9 _-]+$/;
export const DESCRIPTION_MAX_LENGTH = 256;

/** Shared shape for the Create / Rotate API key form fields. */
export interface ApiKeyFormValues {
  description: string;
  expiryDate: string;
  name: string;
}

export const emptyApiKeyFormValues: ApiKeyFormValues = {
  description: '',
  expiryDate: '',
  name: '',
};

/** Returns a validation message for the key name, or '' when valid. */
export const validateKeyName = (name: string): string => {
  const trimmed = name.trim();
  if (!trimmed) {
    return t`Name is required`;
  }
  if (trimmed.length < KEY_NAME_MIN_LENGTH) {
    return t`Name must be at least 3 characters`;
  }
  if (!KEY_NAME_PATTERN.test(trimmed)) {
    return t`Name can only contain letters, numbers, hyphens, underscores, and spaces`;
  }
  return '';
};

/** Match the API sample format (2026-12-01T00:00:00Z) using the picked calendar day. */
export const toExpiresAt = (date: Date): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}T00:00:00Z`;
};
